// Copyright (c) 2023 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { catchError, filter, map, mergeMap, tap } from "rxjs/operators"
import * as Actions from "../actions"
import * as Slice from "../slices/additionalUi"
import { AUTO_NARRATIVE } from "./index"

export type StorageWriter = (value: boolean) => void

export const persist: StorageWriter = (value) => {
  localStorage.setItem(AUTO_NARRATIVE, value.toString())
}

export const persistAutoNarrative = (persist: StorageWriter) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Slice.setAutoNarrative.match),
      mergeMap(action => of(action.payload.autoNarrative).pipe(
        tap(persist),
        map(_ => Actions.autoNarrativePersisted()),
        catchError(_ => of(Actions.autoNarrativePersistFailed())),
      )),
    )

export default persistAutoNarrative(persist)

